var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03455 0.437256C9.20782 0.437256 11.8292 2.9538 11.8292 6.06636C11.8292 9.31138 8.17306 13.9471 6.03455 16.265C3.89604 13.9471 0.170898 9.31138 0.170898 6.06636C0.170898 2.9538 2.7923 0.437256 6.03455 0.437256ZM6.03455 3.28492C7.41424 3.28492 8.58697 4.41074 8.58697 5.73524C8.58697 7.12596 7.41424 8.25178 6.03455 8.25178C4.58589 8.25178 3.41315 7.12596 3.41315 5.73524C3.41315 4.41074 4.58589 3.28492 6.03455 3.28492Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d5226f1254925e5605b24533ff0c739d.svg";
export { ForwardRef as ReactComponent };